// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sp_a bhf_a bhf_r bhf_j","Photos__img":"sp_b bhf_b"};